import {setInitialState} from '../../../utils/reducerOperations';
export const Default=()=>({
    downloadReportApi:setInitialState(),
    participationTableApi:setInitialState(),
});